module.exports = __webpack_public_path__ + "img/EGS_icon_03.b6896979.svg";